import { useState } from 'react';
import { toast } from 'react-toastify';

import settingsApi from '../../../APIs/settings';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';
import { useRoot } from '../../../context/RootProvider';
import {
  Avatar,
  BrowseFile,
  Button,
  Tag,
  Typography,
} from '../../../designComponents';
import { fake_avatar_url, requestAPI, uploadFilesToS3 } from '../../../utils';
import { Content, ProfileContainer } from './style';

const ProfileInformation = () => {
  const { auth: user, updateAuth } = useRoot();
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const [files, setFiles] = useState<File[]>([]);

  const handleUploadPhoto = async () => {
    try {
      if (files && files.length === 0) {
        return;
      }
      setLoading(true);
      const uploadedKeys = await uploadFilesToS3(files);
      if (uploadedKeys && uploadedKeys?.length > 0) {
        const avatarUrls = uploadedKeys[0].key;
        const updatedData = await requestAPI(
          settingsApi.updatePersonalInfo({
            avatar: avatarUrls,
            fullName: user?.fullName,
            contactInfo: user?.contactInfo,
          })
        );
        if (updatedData) {
          updateAuth({ ...updatedData });
        }
        toast.success('Photo uploaded successfully');
        setLoading(false);
        setOpen(false);
      }
    } catch (error) {
      console.error('Error uploading photo:', error);
      toast.error('Failed to upload photo');
      setLoading(false);
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <ProfileContainer>
        <Avatar src={user?.avatar || fake_avatar_url} size="xl" />{' '}
        <Content>
          <Typography size={16}>{user?.fullName}</Typography>
          <Typography className="mail">{user?.emailAddress}</Typography>
          <Tag type="caution">{user?.role}</Tag>
        </Content>
        <ConfirmationModal
          isOpen={open}
          onClose={() => setOpen(false)}
          message="Choose an Image"
          title="Profile Photo Upload"
        >
          <BrowseFile
            files={files}
            setFiles={setFiles}
            accepts=".png, .svg, .jpeg"
            showFileBrowser={files.length === 0}
          />

          <Button onClick={handleUploadPhoto} isLoading={loading}>
            Upload
          </Button>
        </ConfirmationModal>
        <Button
          variant="secondary"
          className="btn-upload"
          onClick={() => setOpen(true)}
        >
          Upload Photo
        </Button>
      </ProfileContainer>
    </div>
  );
};

export default ProfileInformation;
